import React, {Component} from 'react';
import {connect} from 'react-redux';
import {createLoadingSelector, getAccountPlan} from '../../../../selectors';
import isEmpty, {applyOnEnum, generateId} from "../../../../utils/helpers";
import {changeServiceLine} from "../../../../actions/dashboardActions/orders.actions";
// import {clearAccountPlanSummary, getAccountPlanSummary} from "../../../../actions/accountPlan.actions";
import moment from "moment";
import DatePicker from "react-datepicker";
import {Form, Formik} from "formik";
import * as Yup from 'yup';
import ServiceOrder from "../ServiceOrder";
import { hideModal, showModal } from "src/actions/modal.actions";
import {getWorkflowDefinitionReasonCodes, getWorkflowDefinitionAttributes} from "src/actions/accountDetailsActions/accountDetails.actions";


class Lines extends Component {

    state = {
        removeAll: true,
        allLines: null,
        mainServiceLineId: null,
        isApplyOnVisible: false,
        applyOnType: Object.keys(applyOnEnum)[0],
        provisionImmediately: false,
        provisionImmediatelyEnabled: true,
        reasonCodes: [],
        workflowAttributes: [],

        minDate: this.props.wizardData.accountInfo && this.props.wizardData.accountInfo.billCycle
            ? this.convertDay(this.props.wizardData.accountInfo.billCycle)
            : this.convertDay((new Date()).getDate())
    }

    convertDay(startDayBillCycle){
        let localdate = new Date();
        let currentMonth = localdate.getMonth();
        let currentYear = localdate.getFullYear();
        let currentDay = localdate.getDate();
        if (startDayBillCycle <= currentDay) {
            return new Date(currentYear, currentMonth, startDayBillCycle);
        }
        else {
            return new Date(currentYear, currentMonth-1, startDayBillCycle);
        }
    }

    getFirstDayOfCurrentMonth() {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), 1);
    }

    componentDidMount() {

        let lines = [];
        let mainServiceLineId;

        this.props.getWorkflowDefinitionReasonCodes(this.props.wizardData.service.planCategory, this.props.wizardData.service.serviceModel.name, 'REMOVE_LINES', 'CAMVIO-WEB')
          .then((response) => {
              const reasonCodes = response.data.apiReasoncodeList || [];
              this.setState({reasonCodes: reasonCodes});
              if (reasonCodes.length > 0 && this.formikProps) {
                  this.formikProps.setFieldValue('reasoncodeId', reasonCodes[0].id);
              }
          })
          .catch((error) => {
              console.error('Error fetching Workflow Definition Reason Codes:', error);
          });

        this.props.getWorkflowDefinitionAttributes(this.props.wizardData.service.planCategory, this.props.wizardData.service.serviceModel.name, 'REMOVE_LINES', 'CAMVIO-WEB')
          .then((response) => {
              const attributesList = Array.isArray(response.data.workflowDefinitionAttributesList) ? response.data.workflowDefinitionAttributesList : [];
              this.setState({workflowAttributes: attributesList});
              if (attributesList.length > 0) {
                  const attribute = attributesList[0];
                  const allowedOptions = [
                      attribute.allowOrderCompletion,
                      attribute.allowStartOfBillCycle,
                      attribute.allowNextBillCycle,
                      attribute.allowSelectADate
                  ].filter(Boolean).length;
                  let defaultApplyOnType = Object.keys(applyOnEnum)[0];

                  if (allowedOptions === 1) {
                      if (attribute.allowOrderCompletion) {
                          defaultApplyOnType = Object.keys(applyOnEnum)[0];
                      } else if (attribute.allowStartOfBillCycle) {
                          defaultApplyOnType = Object.keys(applyOnEnum)[1];
                      } else if (attribute.allowNextBillCycle) {
                          defaultApplyOnType = Object.keys(applyOnEnum)[2];
                      } else if (attribute.allowSelectADate) {
                          defaultApplyOnType = Object.keys(applyOnEnum)[3];
                      }
                  } else if (allowedOptions > 1) {
                      if (attribute.orderCompletionDefault && attribute.allowOrderCompletion) {
                          defaultApplyOnType = Object.keys(applyOnEnum)[0];
                      } else if (attribute.startOfBillCycleDefault && attribute.allowStartOfBillCycle) {
                          defaultApplyOnType = Object.keys(applyOnEnum)[1];
                      } else if (attribute.nextBillCycleDefault && attribute.allowNextBillCycle) {
                          defaultApplyOnType = Object.keys(applyOnEnum)[2];
                      } else if (attribute.selectADateDefault && attribute.allowSelectADate) {
                          defaultApplyOnType = Object.keys(applyOnEnum)[3];
                      } else {
                          if (attribute.allowOrderCompletion) {
                              defaultApplyOnType = Object.keys(applyOnEnum)[0];
                          } else if (attribute.allowStartOfBillCycle) {
                              defaultApplyOnType = Object.keys(applyOnEnum)[1];
                          } else if (attribute.allowNextBillCycle) {
                              defaultApplyOnType = Object.keys(applyOnEnum)[2];
                          } else if (attribute.allowSelectADate) {
                              defaultApplyOnType = Object.keys(applyOnEnum)[3];
                          }
                      }
                  }
                  let provisionImmediately = false;
                  let provisionImmediatelyEnabled = false;

                  if (!attribute.allowProvisionImmediately) {
                      provisionImmediately = false;
                      provisionImmediatelyEnabled = false;
                  } else {
                      const isOrderCompletionOrBillCycle = (defaultApplyOnType === Object.keys(applyOnEnum)[0] || defaultApplyOnType === Object.keys(applyOnEnum)[1]);

                      if (isOrderCompletionOrBillCycle) {
                          provisionImmediately = true;
                          provisionImmediatelyEnabled = false;
                      } else {
                          provisionImmediately = attribute.provisionImmediatelyDefault !== undefined ? attribute.provisionImmediatelyDefault : false;
                          provisionImmediatelyEnabled = true;
                      }
                  }

                  this.setState({
                      applyOnType: defaultApplyOnType,
                      provisionImmediately: provisionImmediately,
                      provisionImmediatelyEnabled: provisionImmediatelyEnabled
                  });

                  if (this.formikProps) {
                      this.formikProps.setFieldValue('applyOn', defaultApplyOnType);
                      this.formikProps.setFieldValue('provisionImmediately', provisionImmediately);
                      if (this.state.reasonCodes.length > 0) {
                          this.formikProps.setFieldValue('reasoncodeId', this.state.reasonCodes[0].id);
                      }
                  }
              } else {
                  this.setState({
                      applyOnType: Object.keys(applyOnEnum)[0],
                      provisionImmediately: true,
                      provisionImmediatelyEnabled: false
                  });
                  if (this.formikProps) {
                      this.formikProps.setFieldValue('applyOn', Object.keys(applyOnEnum)[0]);
                      this.formikProps.setFieldValue('provisionImmediately', true);
                      if (this.state.reasonCodes.length > 0) {
                          this.formikProps.setFieldValue('reasoncodeId', this.state.reasonCodes[0].id);
                      }
                  }
              }
          })
          .catch((error) => {
              console.error('Error fetching Workflow Definition Attributes:', error);
          });

        this.props.wizardData.service.serviceLines.map(serviceLine => {

            // Activate removal for all lines by default
            lines.push({
                id: serviceLine.serviceLineId,
                planRelation: serviceLine.planRelation,
                action: "REMOVE",
            });

            // Store Main line id
            if (serviceLine.planRelation === "Main") {
                mainServiceLineId = serviceLine.serviceLineId;
            }
        });

        this.setState({
            allLines: lines,
            mainServiceLineId: mainServiceLineId,
        });
    }

    toggleRemoveAll = (activate, formProps) => {
        this.setState({removeAll: activate});
        formProps.setFieldValue('lines', activate ? this.state.allLines : []);
    }

    toggleLine = (activate, formProps, service) => {

        // If user clicks Main line
        if (service.planRelation === "Main") {

            // Uncheck all other toggles
            this.toggleRemoveAll(activate, formProps);
        }

        // If user clicks non-Main line
        else {

            let lines = formProps.values.lines;

            // Check
            if (activate) {

                // Add line
                lines.push({
                    id: service.serviceLineId,
                    planRelation: service.planRelation,
                    action: "REMOVE",
                });

                // Store lines
                formProps.setFieldValue('lines', lines);
            }

            // Uncheck
            else {

                // Find line and remove it
                lines = lines.filter(line => line.id !== service.serviceLineId);

                // Store lines
                formProps.setFieldValue('lines', lines);
            }
        }
    }

    handleApplyOnDropdown = () => {
        this.setState((prevState) => ({
            isApplyOnVisible: !prevState.isApplyOnVisible
        }));
    }

    handleChangeApplyOn = (value, setFieldValue) => {
        setFieldValue('applyOn', value);
        setFieldValue('applyDate', null);
    }

    handleSetApplyDate = (date, setFieldValue) => {

        if (date instanceof Date) {
            date = moment(date).format('YYYY-MM-DD');
        }

        if (date) {
            setFieldValue('applyDate', date);
        }
    }

    setDate = () => {
        this._calendar.setOpen(true);
        this.setState({isApplyOnVisible: false})
    }

    handleOnSubmit = (values, actions) => {

        let changeLineRequest = values;
        if (isEmpty(changeLineRequest.applyDate)) {
            delete changeLineRequest.applyDate;
        }

        this.props.changeServiceLine(changeLineRequest).then(response => {
            if (response && response.success) {
                let updatedValues = values;
                updatedValues['orderId'] = response.id;
                this.handleNext({...updatedValues});
            }
        });
    }
    handleNext = (values) => {
        const { next } = this.props;

        if (!next) {
            return;
        }

        next({
            values: values,
        });
    }

    renderApplyOnText = (applyOn, applyDate) => {
        const provisionText = this.state.provisionImmediately ? 'with immediate provisioning' : 'without immediate provisioning';

        if(applyOn === Object.keys(applyOnEnum)[3]) {
            return `Are you sure you would like for your plan to be applied on ${applyDate} ${provisionText}?`
        } else {
            return `Are you sure you would like for your plan to be applied on ${applyOnEnum.valueOf()[applyOn]} ${provisionText}?`
        }
    }

    onApplyOnTypeChangeClickHandler = (e) => {
        const value = e.target.value;
        this.setState({ applyOnType: value });

        if (value && (value === Object.keys(applyOnEnum)[0] || value === Object.keys(applyOnEnum)[1])) {
            this.setState({
                provisionImmediately: true,
                provisionImmediatelyEnabled: false
            });
            if (this.formikProps) {
                this.formikProps.setFieldValue('provisionImmediately', true);
            }
        } else {
            const { workflowAttributes } = this.state;
            const defaultValue = Array.isArray(workflowAttributes) && workflowAttributes.length > 0 && workflowAttributes[0].provisionImmediatelyDefault !== undefined
                ? workflowAttributes[0].provisionImmediatelyDefault
                : false;

            this.setState({
                provisionImmediately: defaultValue,
                provisionImmediatelyEnabled: true
            });

            if (this.formikProps) {
                this.formikProps.setFieldValue('provisionImmediately', defaultValue);
            }
        }

        if (this.formikProps) {
            this.formikProps.setFieldValue('applyOn', value);

            if (value === Object.keys(applyOnEnum)[3]) {
                const today = moment().format('YYYY-MM-DD');
                this.formikProps.setFieldValue('applyDate', today);
                this.setState({
                    provisionImmediatelyEnabled: true
                });
                this.formikProps.setFieldValue('provisionImmediately', this.state.provisionImmediately);
            } else {
            this.formikProps.setFieldValue('applyDate', null);
            }
        }
    }

    onProvisionImmediatelyChangeHandler = (e) => {
        this.setState({ provisionImmediately: e.target.checked });
        if (this.formikProps) {
            this.formikProps.setFieldValue('provisionImmediately', e.target.checked);
        }
    }

    handlChangeStartDateBillCycle = (date) => {
        if (date instanceof Date) {
            date = moment(date).format('YYYY-MM-DD');
        }

        if (this.formikProps && date) {
            this.formikProps.setFieldValue('applyDate', date);
            const selectedDate = moment(date);
            const today = moment();

            if (selectedDate.isSameOrBefore(today, 'day')) {
                this.setState({
                    provisionImmediately: true,
                    provisionImmediatelyEnabled: false
                });
                this.formikProps.setFieldValue('provisionImmediately', true);
            } else {
                const { workflowAttributes } = this.state;
                const defaultValue = Array.isArray(workflowAttributes) && workflowAttributes.length > 0 && workflowAttributes[0].provisionImmediatelyDefault !== undefined
                    ? workflowAttributes[0].provisionImmediatelyDefault
                    : false;

                this.setState({
                    provisionImmediately: defaultValue,
                    provisionImmediatelyEnabled: true
                });
                this.formikProps.setFieldValue('provisionImmediately', defaultValue);
            }
        }
    }

    openDatepicker = () => {
        if (this._calendar) {
            this._calendar.setOpen(true);
        }
    }



    getDefaultDescription(applyOnKey) {
        switch(applyOnKey) {
            case Object.keys(applyOnEnum)[0]:
                return "Billing will take effect immediately, and provisioning will be triggered as soon as the request is submitted.";
            case Object.keys(applyOnEnum)[1]:
                return "Billing will take effect as of the start of the current billing cycle, and provisioning will be triggered immediately.";
            case Object.keys(applyOnEnum)[2]:
                return "Billing will take effect at the start of the next billing cycle (1 second before midnight UTC). No proration will be applied.";
            case Object.keys(applyOnEnum)[3]:
                return "Billing will take effect on the selected date and time.";
            default:
                return "";
        }
    }

    handleShowApplyOnModal = () => {
        const { showModal } = this.props;
        const { workflowAttributes, reasonCodes } = this.state;
        let attributes = null;
        if (Array.isArray(workflowAttributes) && workflowAttributes.length > 0) {
            attributes = workflowAttributes[0];
        } else {
            attributes = {
                allowOrderCompletion: true,
                allowStartOfBillCycle: false,
                allowNextBillCycle: false,
                allowSelectADate: false,
                allowProvisionImmediately: true,
                orderCompletionDefault: true,
                startOfBillCycleDefault: false,
                nextBillCycleDefault: false,
                selectADateDefault: false,
                provisionImmediatelyDefault: true
            };
        }
        const mockStatusTransition = {
            name: 'APPLY ON',
            fromStatus: 'Current',
            toStatus: 'Updated',
            workflowDefinitionAttributes: attributes,
            workflowDefinitionReasoncodes: reasonCodes.map(reason => ({
                reasoncode: {
                    id: reason.id,
                    description: reason.description
                }
            })),
            isLinesModal: true
        };

        showModal('ACCOUNT_STATUS_CHANGE_MODAL', {
            accountInfo: this.props.wizardData.accountInfo,
            statusTransition: mockStatusTransition,
            onAccountStatusChange: this.handleApplyOnModalSubmit,
            onModalSubmit: this.handleModalValuesSubmit,
            currentValues: {
                applyOnType: this.state.applyOnType,
                applyOnDate: this.formikProps && this.formikProps.values.applyDate ? moment(this.formikProps.values.applyDate).format('YYYY-MM-DD') : null,
                provisionImmediately: this.state.provisionImmediately,
                reasoncodeId: this.formikProps ? this.formikProps.values.reasoncodeId : null
            }
        });
    }

    handleModalValuesSubmit = (applyOnType, applyOnDate, provisionImmediately, reasoncodeId) => {
        if (this.formikProps) {
            this.formikProps.setFieldValue('applyOn', applyOnType);
            const formattedDate = applyOnDate ? moment(applyOnDate).format('YYYY-MM-DD') : applyOnDate;
            this.formikProps.setFieldValue('applyDate', formattedDate);
            this.formikProps.setFieldValue('provisionImmediately', provisionImmediately);
            this.formikProps.setFieldValue('reasoncodeId', reasoncodeId);
        }
        this.setState({
            applyOnType: applyOnType,
            provisionImmediately: provisionImmediately
        });
    }

    handleApplyOnModalSubmit = () => {
    }

    getApplyOnTypeLabel = () => {
        const { applyOnType } = this.state;
        if (applyOnType && applyOnEnum.valueOf()[applyOnType]) {
            return applyOnEnum.valueOf()[applyOnType].toUpperCase();
        }
        return "ORDER COMPLETION";
    }

    getApplyOnTypeDescription = () => {
        const { applyOnType } = this.state;
        switch(applyOnType) {
            case Object.keys(applyOnEnum)[0]:
                return "Order Completion";
            case Object.keys(applyOnEnum)[1]:
                return "Start of Bill Cycle";
            case Object.keys(applyOnEnum)[2]:
                return "Next Bill Cycle";
            case Object.keys(applyOnEnum)[3]:
                if (this.formikProps && this.formikProps.values.applyDate) {
                    return `Selected Date: ${moment(this.formikProps.values.applyDate).format('MM/DD/YYYY')}`;
                }
                return "Select a Date";
            default:
                return "Order Completion";
        }
    }

    getSelectedReasonLabel = () => {
        const { reasonCodes } = this.state;

        if (!this.formikProps || !this.formikProps.values.reasoncodeId) {
            if (reasonCodes.length === 0) {
                return "NO REASON CODES LOADED";
            }
            return reasonCodes.length > 0 ? (reasonCodes[0].name || reasonCodes[0].description).toUpperCase() : "NO REASON SELECTED";
        }

        const selectedReason = reasonCodes.find(reason => reason.id === this.formikProps.values.reasoncodeId);
        return selectedReason ? (selectedReason.name || selectedReason.description).toUpperCase() : "NO REASON SELECTED";
    }

    getSelectedReasonDescription = () => {
        const { reasonCodes } = this.state;

        if (!this.formikProps || !this.formikProps.values.reasoncodeId) {
            if (reasonCodes.length === 0) {
                return "No Reason Codes Loaded";
            }
            return reasonCodes.length > 0 ? reasonCodes[0].description : "";
        }

        const selectedReason = reasonCodes.find(reason => reason.id === this.formikProps.values.reasoncodeId);
        return selectedReason ? selectedReason.description : "";
    }

    render() {

        const {
            removeAll,
            allLines,
            mainServiceLineId,
            isApplyOnVisible,
            minDate,

        } = this.state;

        const {
            changeServiceLineLoading,
            wizardData,
            showModal,
            hideModal,
        } = this.props;


        return (
            <>
                {allLines !== null &&
                <Formik
                  onSubmit={() => {
                  }}
                  initialValues={{
                      name: 'SERVICE_REMOVE_SERVICELINES_' + generateId(),
                      source: 'CAMVIO-WEB',
                      type: 'REMOVE_LINES',
                      accountId: wizardData.accountInfo.id,
                      // existingServiceLineId: '',
                      // note: '',
                      applyOn: Object.keys(applyOnEnum)[0],
                      applyDate: null,
                      reasoncodeId: null,
                      provisionImmediately: false,
                      lines: allLines,
                  }}
                  validationSchema={Yup.object().shape({
                      reasoncodeId: Yup.number()
                          .test('conditional-required', 'Please select a reason', (value) => {
                              if (this.state.reasonCodes.length === 0) {
                                  return true;
                              }
                              return value !== null && value !== undefined;
                          })
                          .nullable(),
                  })}
                  render={(formProps) => {
                      // Store formProps reference for other methods
                      this.formikProps = formProps;

                      if (formProps.isSubmitting) {
                          showModal('GENERIC_MODAL', {
                              title: "Plan Applied Date Confirmation",
                              text: this.renderApplyOnText(formProps.values.applyOn, formProps.values.applyDate),
                              size: 'md',
                              cancelText: "No",
                              okText: "Yes",
                              onOk: () => {
                                  formProps.setSubmitting(false);
                                  this.handleOnSubmit(formProps.values, formProps);
                              },
                              onCancel: () => formProps.setSubmitting(false)
                          });
                      }

                      return (
                        <Form className="cmv-form" autoComplete="off">
                            <div className="tab-content wizard-content mh-70 overflow-scroll px-4">

                                <div className="services-summary-applyon d-flex justify-content-sm-end justify-content-center">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="d-flex justify-content-end align-items-start">
                                                <div className="mr-4">
                                                    <label className="text-muted small mb-1 d-block">Apply On</label>
                                                    <div
                                                      className="cursor-pointer"
                                                      onClick={this.handleShowApplyOnModal}
                                                      style={{ cursor: "pointer" }}
                                                    >
                                                        <span className="btn btn-sm btn-outline-secondary dropdown-toggle" style={{verticalAlign: 'middle'}}>{this.getApplyOnTypeLabel()}</span>
                                                        {this.getApplyOnTypeDescription() && (
                                                            <>
                                                                <div className="text-muted small mt-1" style={{fontSize: '12px'}}>
                                                                    {this.getApplyOnTypeDescription()}
                                                                </div>
                                                                {(this.state.applyOnType === Object.keys(applyOnEnum)[0] || this.state.applyOnType === Object.keys(applyOnEnum)[1] || this.state.provisionImmediately) && (
                                                                    <div className="text-muted small mt-1" style={{fontSize: '12px'}}>
                                                                        Provision Immediately
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                <div>
                                                    <label className="text-muted small mb-1 d-block">Reason</label>
                                                    <div
                                                      className="cursor-pointer"
                                                      onClick={this.handleShowApplyOnModal}
                                                      style={{ cursor: "pointer" }}
                                                    >
                                                        <span className="badge badge-primary text-white" style={{fontSize: '.875rem', padding: '0.25rem 0.5rem', lineHeight: '1.7', borderRadius: '0.2rem', verticalAlign: 'middle'}}>
                                                            {this.getSelectedReasonLabel()}
                                                        </span>
                                                        {this.getSelectedReasonDescription() && (
                                                            <div className="text-muted small mt-1" style={{fontSize: '12px'}}>
                                                                {this.getSelectedReasonDescription()}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                                            </div>
                            </div>
                        </div>
                    </div>


                                <ServiceOrder
                                  serviceInfo={wizardData.service}
                                  removeAll={removeAll}
                                  toggleRemoveAll={this.toggleRemoveAll}
                                  toggleLine={this.toggleLine}
                                  formProps={formProps}
                                  changeServiceLineLoading={changeServiceLineLoading}
                                />

                            </div>

                            <div className="wizard-footer d-flex justify-content-between px-5">


                                <button
                                  type="submit"
                                  className="btn btn-primary btn-next-tab ml-auto"
                                  disabled={
                                    changeServiceLineLoading ||
                                    isEmpty(formProps.values.lines) ||
                                    (this.state.reasonCodes.length > 0 && !formProps.values.reasoncodeId) ||
                                    (formProps.values.applyOn === Object.keys(applyOnEnum)[3] && isEmpty(formProps.values.applyDate))
                                  }
                                >
                                    {changeServiceLineLoading
                                      ? <i className="fas fa-fw fa-spin fa-spinner" style={{ marginLeft: "5px" }} />
                                      : "REMOVE"
                                    }
                                </button>
                            </div>

                        </Form>
                      )
                  }}
                />
                }
            </>
        )
    }
}

// const accountPlanLoader = createLoadingSelector(['GET_ACCOUNT_PLAN_SUMMARY']);
const changeServiceLineLoader = createLoadingSelector(["CHANGE_SERVICE_LINE"]);

const mapStateToProps = (state) => {

    // const accountPlanLoading = accountPlanLoader(state);
    const changeServiceLineLoading = changeServiceLineLoader(state);

    return {
        // accountPlanLoading,
        changeServiceLineLoading,
    }
};

const mapDispatchToProps = {
    changeServiceLine,
    showModal,
    hideModal,
    getWorkflowDefinitionReasonCodes,
    getWorkflowDefinitionAttributes
    // getAccountPlanSummary,
    // clearAccountPlanSummary,
};

export default connect(mapStateToProps, mapDispatchToProps)(Lines);

